import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mesa-de-partes-virtual',
  templateUrl: './mesa-de-partes-virtual.component.html',
  styleUrls: ['./mesa-de-partes-virtual.component.css']
})
export class MesaDePartesVirtualComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
